export default __webpack_public_path__ + "static/import-data-0075ded7ed9516cc2b9ab4d30b9c4eff.svg";